const channelsDefaultMessages = {
  sms: {
    text: '',
    amount_best_offers: null,
  },
  whatsapp: {
    text: '',
    amount_best_offers: null,
    attachment: {
      data_url: '',
      thumbnail_url: '',
      mimetype: '',
      filename: '',
    },
    type: '',
  },
  push: {
    text: '',
    amount_best_offers: null,
    title: '',
    amount_best_offers_title: null,
    inner_message_title: '',
    inner_message_text: '',
    inner_amount_best_offers: null,
    inner_amount_best_offers_title: null,
    image_url: '',
    action: {
      type: '',
      link: '',
      reference_id: '',
    },
  },
  email: {
    text: '',
    amount_best_offers: null,
    subject: '',
    amount_best_offers_subject: null,
    email_configuration_type: '',
    processed_html: '',
    simple_email_configuration: {
      text: '',
      amount_best_offers: null,
      subject: '',
      amount_best_offers_subject: null,
      header_image: '',
      image: '',
      click_to_call_button_text: '',
      click_to_call_button_link: '',
      footer: '',
    },
    html_email_configuration: {
      text: '',
      amount_best_offers: null,
      has_uploaded_file: false,
      filename: '',
      url: '',
      amount_best_offers_subject: null,
      uploaded_at: '',
    },
    builder_email_configuration: '',
  },
}

export default channelsDefaultMessages
